<template>
  <div class="cert" v-loading="pageLoading">
    <!-- <detail-video></detail-video> -->
    <div class="passAll" v-if="isPassAll && baseInfo.is_cert && activeTab == 6">
      <div>
        <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/passAllClose.png"
          class="close" @click="isPassAll = false" />
        <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/examinPassAll.png" />
      </div>
    </div>
    <el-dialog custom-class="orderDialog" title="" :visible.sync="orderShow" width="409px" @close="orderShow = false">
      <div class="orderShow">
        <van-image class="cover" width="100%" fit="cover" :error-icon="$placeImg" :loading-icon="$placeImg"
          :src="baseInfo.cover">
        </van-image>
        <div class="detail">
          <p class="title">{{ baseInfo.name }}</p>
          <p class="number">有限期：1年</p>
          <p class="pay">￥{{ baseInfo.price }}</p>
        </div>
      </div>
      <div class="orderBtn">
        <p>
          实付金额：<span>￥{{ baseInfo.price }}</span>
        </p>
        <p @click="toBuy">确认支付</p>
      </div>
    </el-dialog>
    <el-dialog title="扫码支付" :visible.sync="dialogVisible" custom-class="payDialog" width="279px" @close="closeBuy">
      <div class="toPay">
        <!-- <span>{{buyTime}}s后关闭</span> -->
        <span>暂时只支持「微信」扫码</span>
        <vue-qr :text="payUrl" width="200" height="200" :margin="0"></vue-qr>
        <!-- <p @click="closeBuy">已完成付款</p> -->
      </div>
    </el-dialog>

    <div class="content" :class="{ constent2: isTrain }">
      <div class="left">
        <div class="top">
          <div class="tip">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2限免，1不限免-->
            <img :src="$free" v-if="lesson && lesson.goods_arr[0].is_free == 2" />
            <img :src="$vip" v-else-if="lesson && lesson.goods_arr[0].is_vip_flat == 1" />
            <img :src="$noVip" v-else />
          </div>
          <van-image class="cover" width="100%" fit="cover" :error-icon="$placeImg" :loading-icon="$placeImg"
            :src="baseInfo.cover">
          </van-image>
          <div class="detail">
            <p class="title">{{ baseInfo.name }}</p>
            <p class="number">{{ lessonNum }}课节</p>
            <div v-if="$route.params.plat_type != 'tuoyu'">
              <!-- VIP会员商品无论是否购买过均可继续购买 -->
              <p class="pay" v-if="!baseInfo.is_buy && baseInfo.category_id != 189 && parseFloat(baseInfo.price)"
                @click="toPay">
                单独购买：{{ baseInfo.price }}元
              </p>
              <p class="pay" v-if="!baseInfo.is_buy && baseInfo.category_id == 189" @click="toPage('./exchange')">
                课程兑换
              </p>
              <!-- 非VIP会员商品 是VIP课程且用户未购买VIP的情况下显示 -->
              <p style="display: none" class="pay" v-if="!vipInfo.is_buy && baseInfo.is_vip_flat == 1"
                @click="toPage('./detailVip?id=' + vipInfo.goods_id)">
                加入VIP免费看
              </p>
            </div>
            <div style="display:block;padding-top: 10px;" v-else-if="!isTrain">
              <img src="@/assets/images/contactMa.png" style="width: 100px;" />
              <p style="text-align:center; font-size:14px;">扫码联系客服开通课程</p>
            </div>
          </div>
        </div>
        <div class="type" :class="{ typeMore: typeList.length > 2, typeLess: typeList.length <= 2 }">
          <div class="type-item" @click="getTag(item.id)" v-for="item in typeList" :key="item.id"
            :class="{ active: item.id == activeTab }">
            {{ item.name }}
          </div>
        </div>
        <div class="detailContent">
          <!-- 课程介绍 -->
          <div class="html" v-html="baseInfo.content_app" v-show="activeTab == 1"></div>

          <!-- 视频列表 -->
          <div class="lesson-list" v-show="activeTab == 2">
            <lessonList :isXiaMen="isXiaMen" :down_list="down_list" :category_id="baseInfo.category_id"
              :goods_course_id="baseInfo.goods_course_id" :list="lessonList" :discipline_id="baseInfo.discipline_id"
              :isBuy="baseInfo.is_buy" :price="parseFloat(baseInfo.price) || 0" :name="baseInfo.name"
              :baseInfo="baseInfo"></lessonList>
          </div>
          <!-- 课程讲义 -->
          <div class="coverImg" v-show="activeTab == 3">
            <img :src="item.cover" v-for="(item, index) in handouts" :key="index" />
          </div>
          <!-- 思维导图 -->
          <div class="coverImg" v-show="activeTab == 4">
            <img :src="item.cover" v-for="(item, index) in map" :key="index" />
          </div>
          <!-- 纸质书籍 -->
          <div class="coverImg" v-show="activeTab == 7">
            <div v-for="(item, index) in paper_book" :key="index">
              <img :src="item.img_url" />
              <p class="btn" @click="jumpBook(item)">立即购买</p>
            </div>
          </div>
          <!-- 示范课程 -->
          <div class="lesson-list" v-show="activeTab == 5">
            <exampleList :list="demonstrate" :isBuy="baseInfo.is_buy"></exampleList>
          </div>
          <!-- 考试  v-if="lesson && lesson.base.is_test"-->

          <div class="tab-content" v-show="activeTab == 6">
            <p class="examinTitle" v-if="id != 774">理论课程考试</p>
            <detailExamin :testInfo="item" v-for="(item, index) in examinList" :key="index"></detailExamin>

            <p class="examinTitle" style="padding-top: 20px" v-if="examinList2.length">实操课程考核</p>
            <div class="tab-content" v-show="activeTab == 6" v-if="examinList2.length">
              <detailVideo :testInfo="{ ...item, discipline_id: baseInfo.discipline_id }"
                v-for="(item, index) in examinList2" :key="index"></detailVideo>
            </div>
          </div>
          <!-- 证书 -->
          <div class="tab-content" v-show="activeTab == 8">
            <cert-save-587 :lessonNm="baseInfo.name" :userName="userName" ref="cert"
              v-if="baseInfo.id == 587"></cert-save-587>
            <cert-save-588 :lessonNm="baseInfo.name" :userName="userName" ref="cert"
              v-else-if="baseInfo.id == 588"></cert-save-588>
            <cert-save-774 :lessonNm="baseInfo.name" :drill_id="baseInfo.drill_id" :userName="userName" ref="cert"
              v-else-if="baseInfo.id == 774"></cert-save-774>
            <cert-save :lessonNm="baseInfo.name" :userName="userName" ref="cert" v-else></cert-save>

          </div>
        </div>
      </div>
      <div class="right" v-if="!isTrain">
        <right :list="list" :books="books"></right>
      </div>
    </div>
    <van-popup :close-on-click-overlay="false" overlay-class="infoSubmit" get-container="body" v-model="infoSubmit"
      width="300px">
      <div class="formMain">
        <p>{{ isXiaMen ? '为确保您顺利参加培训，请您完善以下信息。' : '为确保您顺利参加考试及正常领取资格证书，请您完善以下信息。' }} </p>
        <p style="color: #F56C6C;font-weight: bold;">上传照片后，即可进行在线学习{{ isXiaMen ? '' : '与考试' }} 。</p>
        <div class="form">
          <div class="formRight">
            <img :src="cover || formImg" />
            <input type="file" accept=".png, .jpg, .jpeg" @change="uploadData" />
          </div>
        </div>

        <div class="btn" @click="formSubmit">确认并保存</div>
      </div>
    </van-popup>
    <van-popup :close-on-click-overlay="false" overlay-class="infoSubmit" get-container="body" v-model="infoSubmit2"
      width="300px">
      <div class="formMain">
        <p>{{ isXiaMen ? '为确保您顺利参加培训，请您完善以下信息。' : '为确保您顺利参加考试及正常领取资格证书，请您完善以下信息。' }} </p>
        <p style="color: #F56C6C;font-weight: bold;">上传照片后，即可进行在线学习{{ isXiaMen ? '' : '与考试' }} 。</p>
        <div class="form">
          <vue-cropper class="cropper" v-if="infoImgCropper" ref="cropper" :img="option.img"
            :outputSize="option.outputSize" :outputType="option.outputType" :canScale='option.canScale'
            :autoCrop='option.autoCrop' :autoCropWidth='option.autoCropWidth' :autoCropHeight='option.autoCropHeight'
            :canMoveBox='option.canMoveBox' :canMove='option.canMove' :centerBox='option.centerBox' :info='option.info'
            :fixedBox='option.fixedBox' :fixedCrop="option.fixedCrop"
            :min-crop-box-size="{ width: 300, height: 420 }"></vue-cropper>
          <div class="formRight">

            <img :src="cover || formImg" />
            <input type="file" accept=".png, .jpg, .jpeg" @change="chooseImg" />
          </div>
        </div>

        <div class="btn" @click="formSubmit2">确认并保存</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import certSave from "./CertSave.vue";
import CertSaveTJ from "./CertSaveTJ.vue";
import CertSave587 from "./CertSave587.vue";
import CertSave588 from "./CertSave588.vue";
import CertSave774 from "./CertSave774.vue";
import right from "@/components/DetailRight.vue";
import lessonList from "@/components/DetailLessonList.vue";
import exampleList from "@/components/DetailExampleList.vue";
import detailExamin from "@/components/detailExamin.vue";
import detailVideo from "@/components/detailVideo.vue"

import formImg from '@/assets/images/formImg.jpg'
import { VueCropper } from 'vue-cropper'
export default {
  components: { VueCropper, certSave, CertSaveTJ, CertSave587, CertSave588, CertSave774, VueQr, right, lessonList, exampleList, detailExamin, detailVideo },
  name: "detail",
  data() {
    return {
      isTrain: false,
      infoSubmit: false,
      infoSubmit2: false,
      infoImgCropper: false,
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 300, // 默认生成截图框宽度
        autoCropHeight: 420, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [5, 7], // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: true, // 固定截图框大小，不允许改变
        fixedCrop: true,
        canMove: true, // 上传图片是否可以移动
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1 // 图片根据截图框输出比例倍数
      },
      formImg,
      cover: '',
      isPassAll: true,
      pass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/pass.jpg",
      noPass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/noPass.jpg",

      typeList: [],
      allTypeList: [
        {
          name: "课程介绍",
          id: 1,
        },
        {
          name: "课程列表",
          id: 2,
        },
        {
          name: "课程讲义",
          id: 3,
        },
        {
          name: "思维导图",
          id: 4,
        },
        {
          name: "示范课程",
          id: 5,
        },
        {
          name: "课程考试",
          id: 6,
        },
        {
          name: "纸质书籍",
          id: 7,
        },
        {
          name: "资质证书",
          id: 8,
        },
      ],
      baseInfo: {},
      lessonNum: 0,
      lessonList: [], //课程列表
      down_list: [],//实操课程
      map: [], //思维导图
      handouts: [], //讲义
      demonstrate: [], //示范课程
      paper_book: [], //纸质书籍
      books: [], //推荐书籍
      payUrl: "",
      orderShow: false,
      dialogVisible: false,
      pageLoading: true,
      buyTimer: null,
      buyTime: 300,
      menu: 2,
      id: 0,
      lesson: "",
      list: [],
      activeTab: 1,
      textContent: "",
      color: ["#666", "#FF4D41", "#6DD400"],
      payTimer: null,
      isPay: false,
      examinList: [], //理论课程考试
      examinList2: [],//实操课程考试
      testInfo: {},
      uploading: null,
      // 厦门培训
      isXiaMen: false
    };
  },
  mounted() {

    // this.videoUpload()
    // this.activeTab = this.$route.query.type=='video' ? 2 : 1
    if (!this.isLogin) {
      this.$store.commit('changeLoginShow', true)
      return
    };

    this.$router.onReady(() => {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.isTrain = this.$trainId.findIndex(item => item == this.id) != -1
        this.isXiaMen = this.id == '776' || this.id == '775';
        localStorage.setItem('trainId', this.isTrain ? this.id : '')
        if (window.sessionStorage.getItem(this.$route.query.id)) {
          this.activeTab = 2
          window.sessionStorage.removeItem(this.$route.query.id)
        } else {
          this.activeTab = this.$route.query.activeTab || 1;
        }
        if (this.plat == '119') {
          this.activeTab = 2
        }
        this.getData();
      }
    });
  },
  methods: {
    chooseImg(e) {
      let file = e.target.files[0];
      // file.size < 1024 * 200 ||
      // if (file.size > 1024 * 1024 * 2) {
      //   this.$toast("请上传符合要求的照片");
      //   return;
      // }
      // 转base64赋值给裁剪组件
      const reader = new FileReader()
      reader.onload = (e) => {
        this.option.img = e.target.result
        this.infoImgCropper = true // 打开裁剪弹窗
      }
      reader.readAsDataURL(file)
    },
    uploadImg(file) {
      let param = new FormData();
      param.append("folder", file);
      this.$request.toUpload(param).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.cover = res.data.fullpath;
          this.formSubmit()
        } else {
          this.$toast(res.msg);
        }
      });
    },
    uploadData(e) {
      let file = e.target.files[0];
      // file.size < 1024 * 200 ||
      if (file.size > 1024 * 1024 * 2) {
        this.$toast("请上传符合要求的照片");
        return;
      }

      let param = new FormData();
      param.append("folder", file);
      this.$request.toUpload(param).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.cover = res.data.fullpath;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    formSubmit() {
      if (!this.cover) {
        this.$toast("请上传照片");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$request.userInfoSubmitCover(this.cover).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.getData();
        } else {
          this.$toast(res.msg);
        }
      });
    },
    formSubmit2() {
      this.$refs.cropper.getCropData((data) => {
        let file = this.base64ToFile(data, 'avatar.png')
        this.uploadImg(file)
      });
    },
    // base64 转 File 对象（必用工具函数）
    base64ToFile(base64, fileName) {
      const arr = base64.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], fileName, { type: mime })
    },
    // 视频上传时触发loading
    videoUpload(type) {
      if (type) {
        this.uploading.close()
      } else {
        this.uploading = this.$loading({
          lock: true,
          text: '上传中',
          customClass: 'videoUpload',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }

    },
    videoUploadError() {
      this.uploading.close();
    },
    getTag(id) {
      this.isPassAll = true
      this.activeTab = id;
    },
    async toBuy() {
      this.orderShow = false;

      var payPrice = Number(this.baseInfo.price);

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // let { is_admin, mobile } = this.$store.state.user;
      // let { openid } = this.$store.state.wx;
      // if (mobile == "17600789950" || mobile == "17600789951" || mobile == '18666666666') {
      //   payPrice = 0.01;
      // }
      let res = await this.$api({
        url: "/api/order/make",
        method: "POST",
        data: {
          amount: payPrice,
          goods_sku_id: this.baseInfo.goods_sku_id,

          // amount:0.01,
          // goods_sku_id:2507,

          pay_type: 12,
          amount_coin: 0,
          amount_diamond: 0,
          amount_award: 0,
        },
      });
      if (res.code == 0) {
        this.$toast.clear();
        // 限免商品
        if (this.baseInfo.is_free == 2) {
          this.$toast("购买成功");
          // if (this.ifVIPDetail) {
          //   this.$store.dispatch("getVIPInfo");
          // }
        } else {
          this.dialogVisible = true;
          this.payUrl = JSON.parse(res.data.pay).code_url;
          this.isPay = true;
          this.payTimer = setTimeout(() => {
            this.getData();
          }, 1000);
        }
      } else {
        this.$toast(res.msg);
      }
      //  this.buyTime = 300
      //  this.buyTimer = setInterval(()=>{
      //    this.buyTime--
      //    if(this.buyTime==0){
      //     clearInterval(this.buyTimer)
      //     this.dialogVisible = false
      //    }
      //  },1000)
    },
    jumpBook(item) {
      window.open(item.url);
    },
    toExamin(item) {
      if (!this.baseInfo.can_exam) {
        this.$toast("您的课程还没有全部学习完成，请学习完全部课程后在参加考试");
        return;
      }
      if (this.baseInfo.can_exam) {
        this.$router.push({
          path: "./examinList",
          query: {
            id: item.id,
            isExamin: true,
          },
        });
      } else {
        this.$toast("您还未满足考试要求");
      }
    },
    closeBuy() { },

    async getData(type) {
      // if(this.$route.query.isVip){
      //   this.getVIPData()
      //   return
      // }
      this.isTrain = this.$trainId.findIndex(item => item == this.id) != -1
      if (!this.isPay && !type) this.pageLoading = true;
      let res = await this.$request.tuoyuDetail({ goods_id: this.id });
      if (!JSON.parse(localStorage.getItem("user")).drill_type && this.isTrain) {
        this.$alert('您的手机号未报名，无法学习。', '提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      } else {
        this.infoSubmit = this.isTrain && !res.data.test_message ? true : false
      }
      this.pageLoading = false;
      this.lessonList = []
      this.demonstrate = []
      this.down_list = []
      if (res.code == 0) {
        if (this.$route.query.chapterId) {
          let chapterId = this.$route.query.chapterId || ''
          let lessonId = this.$route.query.lessonId || ''
          let speakId = this.$route.query.speakId || ''
          let chapterInfo = res.data.list.find(item => item.id == chapterId)
          chapterInfo.show = true
          let lessonInfo = null

          if (lessonId) {
            console.log('lessonId', lessonId)
            lessonInfo = chapterInfo.lesson.find(item => item.id == lessonId)
            lessonInfo.show = true
          }
          if (speakId) {
            console.log('speakId', speakId)
            lessonInfo.speak.find(item => item.id == speakId).show = true
          }

        }
        this.lessonList = res.data.list; //课程列表
        this.down_list = res.data.down_list

        if (this.$route.query.chapterId) {
          this.$nextTick(() => {
            let el = document.getElementsByClassName('lessonShow')
            let ele = el[el.length - 1]
            let top = ele.offsetTop - document.getElementsByClassName('appContent')[0].offsetTop
            console.log(top)
            document.getElementsByClassName('appContent')[0].scrollTo(0, top)
          })
        }


        this.lessonNum = this.flatArr(this.lessonList, []).length;
        this.map = res.data.map; //思维导图
        this.handouts = res.data.handouts; //讲义
        this.demonstrate = res.data.demonstrate; //示范课程
        this.paper_book = res.data.paper_book; //纸质书籍
        this.baseInfo = res.data.goods_info; //课程介绍
        this.baseInfo.is_buy = res.data.is_buy;
        this.baseInfo.can_exam = res.data.can_exam;
        this.baseInfo.exam_pass = res.data.exam_pass;
        this.baseInfo.test_message = res.data.test_message;
        this.baseInfo.test_id = res.data.base.test_id;
        this.baseInfo.playmode_id = res.data.base.playmode_id;
        this.baseInfo.is_cert = res.data.is_cert;
        this.baseInfo.drill_id = res.data.drill_id;
        this.baseInfo.discipline_id = res.data.base.id;
        this.baseInfo.goods_course_id = res.data.goods_course_id

        if (this.baseInfo.is_cert) {
          this.$nextTick(() => {
            this.$refs.cert.getData(res.data.base.id)
          })
        }
        let examRes = await this.$request.detailExaminList(res.data.base.id);
        if (type) {
          this.uploading.close();
          this.$toast('上传成功');
        }
        if (examRes.code == 0) {
          this.examinList = examRes.data && examRes.data.list ? examRes.data.list : [];
          this.examinList2 = examRes.data && examRes.data.v_list ? examRes.data.v_list : [];
        } else {
          this.$toast(examRes.msg);
        }
        let typeShow = [
          this.baseInfo.content_app,
          this.lessonList && this.lessonList.length || this.down_list && this.down_list.length,
          this.handouts.length,
          this.map.length,
          this.demonstrate.length,
          this.examinList.length,
          this.paper_book.length,
          res.data.is_cert,
        ];
        this.typeList = this.allTypeList.filter((item, index) => {

          return typeShow[index];
        });
        // 1 为课程  2为培训
        this.activeTab = typeShow.findIndex(item => item) + 1
        // this.activeTab = this.ifVIPDetail ? 0 : 1
        // console.log(this.typeList)
        if (this.isPay) {
          if (!res.data.is_buy) {
            this.payTimer = setTimeout(() => {
              this.getData();
            }, 1000);
          } else {
            this.isPay = false;
            this.dialogVisible = false;
          }
        }
      } else {
        this.$toast(res.msg);
      }
      let res2 = await this.$request.tuoyuDetailBooks({
        goods_category_id: this.baseInfo.category_id,
      });
      if (res2.code == 0) {
        this.books = res2.data;
      } else {
        this.$toast(res.msg);
      }
    },
    async getVIPData() {
      if (!this.isPay) this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/platform/goods/detail",
        data: {
          goods_id: this.id,
          plat: this.plat,
        },
      });
      this.pageLoading = false;
      if (res.code == 0) {
        this.baseInfo = res.data.goods_arr[0];
        this.baseInfo.is_buy = res.data.is_buy;
        this.baseInfo.is_vip = res.data.is_vip;
        this.plat_vip = res.data.plat_vip;

        // this.ifVIPDetail = res.data.goods_arr[0].category_id == 102
        this.typeList = this.typeList.slice(0, 1);
        this.$store.commit("SET_VIP", this.plat_vip);
        // this.activeTab = this.ifVIPDetail ? 0 : 1
        // console.log(this.typeList)
        if (this.isPay) {
          if (!res.data.is_buy) {
            this.payTimer = setTimeout(() => {
              this.getData();
            }, 1000);
          } else {
            this.isPay = false;
            this.dialogVisible = false;
          }
        }
      } else {
        this.$toast(res.msg);
      }
    },
    flatArr(arr, idArr) {
      let myArr = [];

      arr.forEach((item) => {
        if (item.lesson && item.lesson.length) {
          // console.log("lesson");
          let arr = [
            { label: "lessonId", value: item.id },
            { label: "myType", value: "chapter" },
          ];
          // console.log(idArr);
          myArr.push(...this.flatArr(item.lesson, [...idArr, ...arr]));
        } else if (item.speak && item.speak.length) {
          // console.log("speak");
          let arr = [
            { label: "chapterId", value: item.id },
            { label: "myType", value: "speak" },
          ];
          myArr.push(...this.flatArr(item.speak, [...idArr, ...arr]));
        } else {
          // console.log("none");
          idArr.forEach((v) => {
            item[v.label] = v.value;
          });
          myArr.push(item);
        }
      });
      return myArr;
    },
    toPay() {
      if (localStorage.getItem("user")) {
        this.orderShow = true;
      } else {
        this.$toast("请登录后购买");
      }
    },
    play(item) {
      if (!item.resource.length) {
      }
      let { ali_media_id, ccid, url, id } = item.resource[0];
      let name = item.lesson_name;
      // console.log(ali_media_id, ccid);
      let videoId = ali_media_id;
      // if(item.is_buy != 1 && item.is_show != 1){ //既没有购买，也不是试看视频
      //     this.$toast('请购买后开始学习')
      //     return
      // }
      this.$store.commit("SET_VIDEO", item);
      // console.log(url);
      let type = "ali";
      if (ccid && ccid != "undefined") {
        type = "cc";
        videoId = ccid;
      } else if (url) {
        type = "url";
      } else if (!ali_media_id) {
        // console.log("none");
        this.$toast("当前视频未上传");
        return;
      }
      // console.log("**");
      this.$router.push(
        `./player2?goods_id=${this.id}&lessonId=${item.lesson_id}&from=课程`
      );
    },

    jumpDetail(item) {
      this.$router.push(`./detail?id=${item.id}`);
    },
    toPage(url) {
      this.$router.push(url);
    },
  },
  computed: {
    vipInfo() {
      return this.$store.state.vipInfo;
    },
    partalName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    userName() {
      return JSON.parse(localStorage.getItem("user")).nickname;
    },
    isLogin() {
      return this.$store.state.user != null;
    },
  },
  watch: {
    isLogin() {
      this.pageLoading = true
      if (this.isLogin) {
        if (this.$route.query.id) {
          this.id = this.$route.query.id;
          this.activeTab = this.$route.query.activeTab || 1;
          this.getData();
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    // console.log("beforeRouteUpdate");
    // console.log(to);
    this.id = to.query.id;
    this.activeTab = this.$route.query.type == "video" ? 2 : 1;
    this.getData();
    next();
  },
  beforeDestroy() {
    clearInterval(this.payTimer);
  },
};
</script>

<style lang="scss">
.van-overlay.infoSubmit {
  background-color: rgba($color: #000000, $alpha: 0.7) !important;
}

body {
  background: #fff;
}

.videoUpload {
  .el-loading-spinner i {
    font-size: 28px;
  }

  .el-loading-spinner .el-loading-text {
    font-size: 20px;
  }
}
</style>
<style lang="scss" scoped>
.formMain {
  color: #333333;
  overflow: hidden;
  padding: 20px;

  >p {
    text-align: center;
    font-size: 16px;
    line-height: 30px;

    &:last-of-type {
      margin-bottom: 36px;
    }
  }

  .form {
    display: flex;
    justify-content: center;

    .cropper {
      width: 124px;
      height: 173px;
      margin-right: 20px;
    }

    .formRight {
      width: 124px;
      height: 173px;
      position: relative;

      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }
  }

  .btn {
    width: 260px;
    height: 36px;
    cursor: pointer;
    margin: 20px auto 0;
    background: #0080d6;
    color: #fff;
    font-size: 16px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px;
  }
}

.examinTitle {
  font-size: 16px;
  padding-bottom: 8px;
  padding-left: 10px
}

.certGet {
  margin: 20px auto 20px;
  cursor: pointer;
  width: 308px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  background: #0080d6;
  border: 0;
  display: block;
}

.passAll {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  >div {
    position: relative;

    .close {
      position: absolute;
      color: #fff;
      right: 0px;
      top: -8px;
      font-size: 30px;
      cursor: pointer;
    }
  }
}

:deep .el-dialog {
  margin-top: 0 !important;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

:deep .orderDialog {
  overflow: hidden;
  border-radius: 20px;

  .el-dialog__header {
    padding: 0 20px;
    height: 54px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 22px;
      color: #333333;
    }
  }

  .el-dialog__body {
    padding: 0;
  }
}

.coverImg {
  img {
    display: block;
    max-width: 100%;
    width: auto;
    margin: 0 auto;
  }

  .btn {
    margin: 10px auto 20px;
    cursor: pointer;
    width: 208px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    background: #0080d6;
  }
}

.examin-content {
  display: flex;
  align-items: center;
  width: 100%;
  background: #f7f7f7;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
  padding: 30px 20px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
}

.examin-content .examinBtn {
  width: 122px;
  text-align: center;
  padding: 10px 0;
  color: #fff;
  border-radius: 5px;

  .isPass {
    margin: 0 auto 20px;
    cursor: pointer;
    height: 37px;
  }

  .btn {
    width: 100%;
    height: 34px;
    line-height: 34px;
    background: #fff;
    color: #0080d6;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      background: #0080d6;
      color: #fff;
    }
  }
}

.opacity {
  opacity: 0.5;
}

.examin-content .examinLeft {
  flex: 1;
}

.examin-content .examinLeft .examinTitle {
  color: #000;
  width: 100%;
  font-size: 16px;
  margin-bottom: 16px;
}

.examin-content .examinLeft .examinDesc {
  display: flex;
  align-items: center;
  padding-bottom: 10px;

  img {
    margin-right: 8px;
  }
}

.examin-content .examinLeft .score span {
  margin-right: 50px;
}

.orderShow {
  display: flex;
  padding: 0 20px;
  margin-bottom: 20px;

  .detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .cover {
    width: 179px !important;
    height: 101px;
    margin-right: 20px;
    border-radius: 10px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .title {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    /*弹性伸缩盒子*/
    -webkit-box-orient: vertical;
    /*子元素垂直排列*/
    -webkit-line-clamp: 2;
    /*可以显示的行数，超出部分用...表示*/
    text-overflow: ellipsis;
    /*（多行文本的情况下，用省略号“…”隐藏溢出范围的文本)*/
  }

  .number {
    font-size: 14px;
  }

  .pay {
    font-size: 20px;
    color: #0080d6;
  }
}

.orderBtn {
  width: 100%;
  height: 54px;
  display: flex;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px dashed #f1f1f1;

  p {
    font-size: 14px;

    span {
      font-size: 20px;
      color: #0080d6;
    }
  }

  p:nth-child(2) {
    width: 116px;
    height: 36px;
    font-size: 16px;
    background: #0080d6;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    color: #ffffff;
    cursor: pointer;
  }
}

:deep .payDialog {
  overflow: hidden;
  border-radius: 20px;
  text-align: center;

  .el-dialog__body {
    padding: 0;
  }
}

.toPay {
  padding-bottom: 30px;

  span {
    color: #666;
    display: block;
    padding-bottom: 20px;
  }

  img {
    width: 200px;
  }

  >p {
    cursor: pointer;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    padding: 10px 0;
    width: 200px;
    text-align: center;
    margin: 20px auto 0;
  }
}

.cert {
  min-height: calc(100vh - 230px);
  overflow: hidden;
  padding-top: 30px;

  .article {
    width: 960px;
    background: #fff;
    min-height: 100vh;
    margin: 20px auto;
    padding: 30px;

    .art-title {
      font-size: 32px;
      margin-bottom: 20px;
    }

    .art-user {
      display: flex;
      align-items: center;
    }

    .user-msg {
      font-size: 16px;
      color: #333;
      margin-left: 10px;

      .sub {
        font-size: 12px;
        color: #666;
      }
    }

    .art-content {
      font-size: 17px;
      word-break: break-word;
      line-height: 1.6;
      margin-top: 16px;
      color: #121212;
      font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC,
        Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei,
        sans-serif;
    }
  }
}

.content {
  display: flex;
  justify-content: space-between;

  .left {
    flex: 0 0 800px;
    border-radius: 12px;
    margin-top: 30px;

    .top {
      display: flex;
      background: #f9f9f9;
      padding: 20px 20px;
      position: relative;
      border-radius: 10px;

      .tip {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 1;

        img {
          width: 50px;
          // height: 35px;
        }
      }

      .cover {
        flex: 0 0 350px;
        margin-right: 20px;
        border-radius: 10px;
        overflow: hidden;
      }

      .detail {
        flex: 0 1 auto;
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        div {
          display: flex;
        }

        .title {
          color: #333;
          font-weight: 500;
          font-size: 26px;
          line-height: 36px;
        }

        .number {
          flex: 1;
          color: #666;
          font-size: 14px;
          margin-top: 5px;
        }

        .pay {
          background: rgb(164, 0, 1);
          color: #fff;
          padding: 0 20px;
          margin-top: 20px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 16px;
          color: #fff;

          &:first-child {
            background: linear-gradient(-180deg, #51b4f7 0%, #0181d6 100%);
          }

          &:nth-child(2) {
            color: #633b11;
            background: linear-gradient(-180deg, #f4cfa7 0%, #daa36c 100%);
          }
        }
      }
    }

    .type {
      display: flex;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 20px;
      border-bottom: 1px solid #dddddd;

      .type-item {
        margin-right: 10px;
        color: #7f7f7f;
        font-size: 20px;
        padding-bottom: 10px;
        margin-right: 40px;
        cursor: pointer;

        &:last-of-type {
          margin-right: 0;
        }
      }

      .active {
        background: none;
        color: #333;
        font-weight: bold;
        border-bottom: 4px solid #0080d6;
      }
    }

    .typeMore {
      // justify-content: space-between;
    }

    .typeLess {

      // justify-content: flex-start;
      .type-item {
        // margin-right: 50px;
      }
    }

    .detailContent {
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
    }

    .lesson-list {}

    .html {
      text-align: center;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .right {
    width: 360px;
    overflow: hidden;
    margin-top: 30px;
  }
}

.constent2 {
  justify-content: center;
}
</style>

<style lang="scss"></style>
